
import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';

export default function News() {
  const newsItems = [
    {
      id: 1,
      date: '2024-01-15',
      title: '新年のご挨拶と営業時間のお知らせ',
      content: '新年あけましておめでとうございます。本年もSALONをよろしくお願いいたします。\n\n1月の営業時間についてお知らせいたします。\n1月1日〜3日：休業\n1月4日より通常営業\n\n皆様のご来店を心よりお待ちしております。',
      category: 'お知らせ'
    },
    {
      id: 2,
      date: '2024-01-10',
      title: '新メニュー「プレミアムトリートメント」開始',
      content: '髪質改善に特化した新メニュー「プレミアムトリートメント」の提供を開始いたします。\n\n最新の技術と厳選された成分を使用し、ダメージを受けた髪を根本から改善します。施術時間は約90分、料金は¥5,500（税込）となります。\n\n詳しくはスタッフまでお気軽にお尋ねください。',
      category: '新メニュー'
    },
    {
      id: 3,
      date: '2024-01-05',
      title: 'スタッフ募集のお知らせ',
      content: '現在、一緒に働いていただけるスタイリストを募集しております。\n\n【募集要項】\n・美容師免許必須\n・経験年数3年以上\n・お客様とのコミュニケーションを大切にできる方\n\n詳細については採用情報ページをご覧いただくか、お電話にてお問い合わせください。',
      category: '採用情報'
    },
    {
      id: 4,
      date: '2023-12-28',
      title: '年末年始の営業時間について',
      content: '年末年始の営業時間についてお知らせいたします。\n\n12月30日：通常営業（10:00-20:00）\n12月31日：短縮営業（10:00-17:00）\n1月1日〜3日：休業\n1月4日より通常営業\n\n年内最後の営業日は混み合うことが予想されます。ご予約はお早めにお願いいたします。',
      category: 'お知らせ'
    },
    {
      id: 5,
      date: '2023-12-20',
      title: '冬の限定メニューのご案内',
      content: '乾燥しがちな冬の髪と頭皮のための限定メニューをご用意いたします。\n\n【冬季限定メニュー】\n・スカルプケア + 保湿トリートメント：¥6,500\n・ダメージ集中ケアコース：¥7,500\n・ヘッドスパ + オイルトリートメント：¥8,000\n\n2024年2月末まで の限定メニューです。ぜひこの機会にお試しください。',
      category: '限定メニュー'
    },
    {
      id: 6,
      date: '2023-12-15',
      title: '年末のご予約について',
      content: '年末に向けてご予約が混み合っております。\n\n特に12月25日以降のご予約は非常に取りにくい状況となっております。年内にご来店をご希望の方は、お早めにご予約をお取りください。\n\nご不便をおかけいたしますが、何卒ご理解いただきますようお願いいたします。',
      category: 'お知らせ'
    },
    {
      id: 7,
      date: '2023-12-10',
      title: 'ヘアケア商品の販売開始',
      content: 'サロンで使用している高品質なヘアケア商品の販売を開始いたします。\n\n【販売商品】\n・オーガニックシャンプー：¥3,200\n・リペアトリートメント：¥3,800\n・ヘアオイル：¥2,500\n・スタイリング剤各種：¥1,800〜\n\nサロンでの仕上がりをご自宅でも再現していただけます。',
      category: '商品情報'
    },
    {
      id: 8,
      date: '2023-12-05',
      title: 'クリスマス限定ヘアセットメニュー',
      content: 'クリスマスシーズンに向けた特別なヘアセットメニューをご用意いたします。\n\n【クリスマス限定】\n・パーティーアップスタイル：¥5,500\n・エレガントダウンスタイル：¥4,500\n・ハーフアップアレンジ：¥4,000\n\n12月24日、25日のご予約は特に混み合います。お早めのご予約をお願いいたします。',
      category: '限定メニュー'
    }
  ];

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-4xl font-light text-black mb-6">
            News
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            サロンの最新情報やお知らせをご確認いただけます。
          </p>
        </div>

        {/* News List */}
        <div className="space-y-6">
          {newsItems.map((news) => (
            <Link
              key={news.id}
              to={`/news/${news.id}`}
              className="group border-b border-gray-200 pb-6 hover:border-black transition-colors cursor-pointer block"
            >
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-3">
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center mb-2">
                    <time className="text-gray-500 sm:w-32 sm:flex-shrink-0 mb-1 sm:mb-0">
                      {news.date}
                    </time>
                    <span className="inline-block text-xs px-2 py-1 bg-gray-100 text-gray-700 sm:ml-4 mb-2 sm:mb-0 w-fit">
                      {news.category}
                    </span>
                  </div>
                  <h2 className="text-lg font-medium text-black group-hover:text-gray-600 transition-colors">
                    {news.title}
                  </h2>
                </div>
                <div className="flex items-center text-gray-400 group-hover:text-black transition-colors mt-2 sm:mt-0 sm:ml-4">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
